import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Sheet, SheetContent, SheetDescription, SheetTitle } from '@/components/ui/sheet';
import type { EditedText, PendingMessage } from '../api-types';

/** «Modifica e approva»: the subject and the text, editable; confirming approves the edited text. */
export function EditSheet({
  item,
  busy,
  onApprove,
  onClose,
}: {
  readonly item: PendingMessage;
  readonly busy: boolean;
  readonly onApprove: (edited: EditedText) => void;
  readonly onClose: () => void;
}) {
  const { t } = useTranslation('communications');
  const [subject, setSubject] = useState(item.message.subject);
  const [text, setText] = useState(item.message.bodyText);
  const empty = subject.trim() === '' || text.trim() === '';
  return (
    <Sheet open onOpenChange={(next) => (next ? undefined : onClose())}>
      <SheetContent className="flex flex-col gap-4 overflow-y-auto p-4">
        <SheetTitle>{t('approvals.editTitle')}</SheetTitle>
        <SheetDescription>{t('approvals.editHelp')}</SheetDescription>
        <label className="flex flex-col gap-1">
          <span className="field-label">{t('approvals.subject')}</span>
          <Input value={subject} onChange={(event) => setSubject(event.target.value)} />
        </label>
        <label className="flex flex-col gap-1">
          <span className="field-label">{t('approvals.text')}</span>
          <textarea
            value={text}
            rows={12}
            onChange={(event) => setText(event.target.value)}
            className="border-input bg-background text-foreground focus-visible:ring-ring w-full rounded-md border p-3 text-sm focus-visible:ring-2 focus-visible:outline-none"
          />
        </label>
        <div className="flex gap-2">
          <Button
            type="button"
            className="min-h-11"
            disabled={busy || empty}
            onClick={() => onApprove({ subject: subject.trim(), bodyText: text.trim() })}
          >
            {t('approvals.editApprove')}
          </Button>
          <Button type="button" variant="outline" className="min-h-11" onClick={onClose}>
            {t('common.cancel')}
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
